(() => {
  const networkFrame = document.querySelector('.network-embed');
  if (networkFrame) {
    const networkOrigin = new URL(networkFrame.src).origin;
    networkFrame.addEventListener('load', () => {
      networkFrame.contentWindow.postMessage({ type: 'tcr-domestic-request-size' }, networkOrigin);
    });
    window.addEventListener('message', event => {
      if (event.origin !== networkOrigin || event.source !== networkFrame.contentWindow) return;
      if (event.data?.type !== 'tcr-domestic-resize') return;
      const height = Number(event.data.height);
      if (Number.isFinite(height) && height >= 100 && height <= 20000) {
        networkFrame.style.height = `${Math.ceil(height) + 24}px`;
      }
    });
  }
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.main-nav');
  if (menu && nav) {
    const closeMenu = () => {
      nav.classList.remove('is-open');
      menu.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-label', window.TCRDomestic.labels.openMenu);
    };
    menu.addEventListener('click', () => {
      const open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      menu.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-label', open ? window.TCRDomestic.labels.closeMenu : window.TCRDomestic.labels.openMenu);
    });
    nav.addEventListener('click', event => {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeMenu();
    });
    document.addEventListener('click', event => {
      if (!nav.contains(event.target) && !menu.contains(event.target)) closeMenu();
    });
  }
})();
